module.exports = __webpack_public_path__ + "static/media/lafool_expertnetwork.7a44e351.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/lafool_expertnetwork.png
// module id = 486
// module chunks = 0